<template>
    <div class="space-y-4">
        <p class="text-gray-600 text-xl font-semibold">Enter your location to see face painters near you.</p>

        <form
            @submit.prevent="updateAddress"
            :action="url"
            method="post"
            class="space-y-2"
        >
            <div class="flex">
                <input
                    v-model="form.location"
                    type="text"
                    class="form-input rounded-r-none"
                    placeholder="Your Location"
                    :class="{ error: form.errors.location }"
                >
                <loading-button
                    :loading="form.processing"
                    class="btn btn-green rounded-l-none"
                >
                    Submit
                </loading-button>
            </div>
            <small
                v-if="form.errors.location"
                class="form-error"
            >
                {{ form.errors.location }}
            </small>
        </form>
    </div>
</template>

<script setup>
import useForm from '@/functions/useForm'

const { url, redirectTo } = defineProps({
    url: {
        type: String,
        required: true,
    },
    redirectTo: String,
})

const form = useForm({
    location: ''
})

const updateAddress = () => {
    form.post(url, {
        onSuccess: () => {
            if(redirectTo) {
                return window.location.assign(redirectTo)
            }
            window.location.assign(window.location.pathname)
        }
    })
}
</script>
